import React from 'react';
import { GatsbyImage } from 'gatsby-plugin-image';
import styled, { css } from 'styled-components';
import {
  breakpointSizes,
  minBreakpointQuery,
  maxBreakpointQuery,
  sectionMargins,
} from '../styles';
import { Container, Heading, HtmlContent, Button } from './ui';

const StyledImageContent = styled.section`
  ${sectionMargins()};
`;

const StyledInner = styled.div`
  display: grid;
  gap: 30px;

  ${minBreakpointQuery.smedium`
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
    gap: calc( 40px + (280 - 40) * ( (100vw - ${breakpointSizes.tiny}px) / (${breakpointSizes.xxxxlarge} - ${breakpointSizes.tiny}) ) );
  `}

  ${minBreakpointQuery.xxxlarge`
    gap: ${({ version }) => (version === 2 ? '280px' : '220px')};
  `}
`;

const StyledImage = styled(GatsbyImage)`
  ${maxBreakpointQuery.smedium`
    aspect-ratio: 2/1;

    @supports not (aspect-ratio: 3/2) {
      max-height: 430px;
    }
  `}

  ${maxBreakpointQuery.small`
    aspect-ratio: 3/2;
  `}

  ${maxBreakpointQuery.tsmall`
    aspect-ratio: 4/3;
  `}

  ${minBreakpointQuery.smedium`
    height: 100%;
  `}

  ${({ flip }) => {
    if (flip) {
      return css`
        ${minBreakpointQuery.smedium`
          grid-row: 1;
          grid-column: 2;
        `}
      `;
    }
  }}

  ${({ version }) => {
    if (version === 2) {
      return css`
        margin-right: -30px;

        ${maxBreakpointQuery.smedium`
          margin-left: -30px;
        `}
      `;
    }
  }}
`;

const StyledContent = styled.div`
  ${minBreakpointQuery.smedium`
    margin-top: 30px;
    margin-bottom: 30px;
  `}

  ${({ version }) => {
    if (version === 2) {
      return css`
        ${minBreakpointQuery.smedium`
          ${({ flip }) => (flip ? 'margin-left: auto;' : 'margin-right: auto;')}
          max-width: 480px;
        `}
      `;
    }
  }}
`;

const StyledText = styled(HtmlContent)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}
`;

const StyledLink = styled(Button)`
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 30px;
  `}
`;

const ImageContent = ({ image, heading, text, link, flip, version }) => (
  <StyledImageContent>
    <Container wide={version === 2}>
      <StyledInner version={version}>
        <StyledImage
          image={image.gatsbyImageData}
          alt={image.alt}
          flip={flip}
          version={version}
        />
        <StyledContent flip={flip} version={version}>
          <Heading>{heading}</Heading>
          {text && <StyledText html={text} />}
          {link && <StyledLink to={link.page}>{link.text}</StyledLink>}
        </StyledContent>
      </StyledInner>
    </Container>
  </StyledImageContent>
);

export default ImageContent;
